import React, { Component } from 'react'
import Card from '../components/Card/PreHome'

// Icon imports
import iconBurger from '../sass/icons/icon-burger.svg'
import iconSuitCase from '../sass/icons/icon-suitcase.svg'
import iconBallotBox from '../sass/icons/icon-ballot-box.svg'
import iconStar from '../sass/icons/icon-star.svg'
import iconTeam from '../sass/icons/icon-team.svg'
import iconFlag from '../sass/icons/icon-flag.svg'

import './pre-home.scss';
import Footer from '../components/Footer'

const cardData = [
    {
        icon: iconBurger,
        text: 'Pequeno Negócio',
        url: '/pequeno-negocio'
    },
    {
        icon: iconSuitCase,
        text: 'Grande Empresa',
        url: '/grande-empresa'
    },
    {
        icon: iconBallotBox,
        text: 'Política',
        url: '/politica'
    },
    {
        icon: iconStar,
        text: 'Personalidade',
        url: '/personalidade'
    },
    {
        icon: iconTeam,
        text: 'Endomarketing',
        url: '/endomarketing'
    },
    {
        icon: iconFlag,
        text: 'Causa',
        url: '/causa'
    }
]

const renderCards = data => data.map(item => <Card {...item} key={item.text} />)

class PreHome extends Component {
    componentDidMount() {
        document.body.classList.toggle('white-bg')
    }
    componentWillUnmount() {
        document.body.classList.remove('white-bg')
    }
    render() {
        return (
          <div>
            <section className="pre-home">
                <h1>A plataforma completa para criar, alimentar e engajar comunidades.</h1>
                <h2>qual o seu negócio?</h2>
                <div className="cards-container">
                    { renderCards(cardData) }
                </div>
            </section>
            <Footer />
          </div>  
        );
    }
}

export default PreHome



// WEBPACK FOOTER //
// ./src/pages/pre-home.js